import { Link } from "react-router-dom";
import { Phone, Navigation, CalendarCheck } from "lucide-react";
import { BUSINESS } from "../data/business";

export const MobileBottomBar = () => (
  <nav
    aria-label="Quick actions"
    data-testid="mobile-bottom-bar"
    className="fixed bottom-0 inset-x-0 z-40 md:hidden bg-ink/95 backdrop-blur-md border-t border-copper/25 grid grid-cols-3"
    style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
  >
    <a href={BUSINESS.phoneHref} data-testid="bottombar-call" className="flex flex-col items-center gap-1 py-3 text-white/85 active:text-copper text-[11px] font-medium min-h-[56px] justify-center">
      <Phone size={19} aria-hidden="true" /> Call
    </a>
    <a href={BUSINESS.directionsUrl} target="_blank" rel="noopener noreferrer" data-testid="bottombar-directions" className="flex flex-col items-center gap-1 py-3 text-white/85 active:text-copper text-[11px] font-medium min-h-[56px] justify-center border-x border-white/10">
      <Navigation size={19} aria-hidden="true" /> Directions
    </a>
    <Link to="/book" data-testid="bottombar-book" className="flex flex-col items-center gap-1 py-3 text-copper text-[11px] font-semibold min-h-[56px] justify-center">
      <CalendarCheck size={19} aria-hidden="true" /> Book
    </Link>
  </nav>
);
